




















































































































import { Component, Watch } from 'vue-property-decorator';
import CurrencyUtils from '@/lib/currencyUtils';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { DepositAccountSettingsModule } from '@/store/Accounts/DepositAccountSettingsModule';
import UpdateAccountDepositPaymentOrderSettingsRequest from '@/models/Accounts/DepositAccounts/Settings/UpdateAccountDepositPaymentOrderSettingsRequest';
import ListUtils from '@/lib/listUtils';
import FieldLabel from '@/components/Shared/FieldLabel.vue';

@Component({ name: 'AccountDepositPaymentOrderSettingsEditDialog', components: { FieldLabel } })
export default class extends SaascadaVueDialog {

    request: UpdateAccountDepositPaymentOrderSettingsRequest = new UpdateAccountDepositPaymentOrderSettingsRequest(DepositAccountSettingsModule.settings.depositPaymentOrderSettings, new Date());

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.request = new UpdateAccountDepositPaymentOrderSettingsRequest(DepositAccountSettingsModule.settings.depositPaymentOrderSettings, new Date());
        }
    }

    get settings() {
        return DepositAccountSettingsModule.settings.depositPaymentOrderSettings;
    }

    get productIssue() {
        return DepositAccountSettingsModule.productIssue;
    }

    get periodTypeOptions() {
        return ListUtils.periodTypeOptions();
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;

            //This needs setting to undefined currently as it is getting stored in the JSON.
            //Plan was to send this and backend ignores it until we get concurrency checking in
            this.request.updatedAt = undefined;

            this.request.oneApprovalThreshold.amount = CurrencyUtils.convertDecimalStringToAmountString(this.request.oneApprovalThreshold.amount);
            this.request.twoApprovalThreshold.amount = CurrencyUtils.convertDecimalStringToAmountString(this.request.twoApprovalThreshold.amount);
            this.request.threeApprovalThreshold.amount = CurrencyUtils.convertDecimalStringToAmountString(this.request.threeApprovalThreshold.amount);

            if (this.request.noticePeriodValue) {
                this.request.noticePeriodValue = +this.request.noticePeriodValue;
            }

            await DepositAccountSettingsModule.editDepositPaymentOrderSettings(this.request);
        }
    }

}
